"use client";

import { ForwardedRef, forwardRef, useContext } from "react";
import ResponsiveMenuContext from "@/contexts/responsiveMenu.context";
import style from "./ResponsiveMenu.module.scss";
import CloseMenu from "@/assets/svg/close/outline.svg";
import Link from "next/link";
import { useSession } from "next-auth/react";
import LoginIcon from "@/assets/svg/login/round.svg";
import { useTranslation } from "@/modules/i18n/i18n.hooks";
import LinkMenu from "./LinkMenu/LinkMenu";
import AppLangChoice from "../AppSetLang/AppLangChoice";
import { SessionNextAuthUser } from "@/modules/user/types/user.types";
import { FormattedMessage } from "react-intl";
import UserMenu from "../Navbar/UserMenu";
import isUserMenuDisplayedContext from "@/contexts/userMenu.context";
import isTransparentDisplayedContext from "@/contexts/transparentDiv.context";
import OutlineIcon from "@/assets/svg/arrow_drop_down/outline.svg";
import { useGetSession } from "@/modules/auth/auth.hooks";

type ResponsiveMenuProps = {
  props: {};
};

const ResponsiveMenu = forwardRef(
  ({ props }: ResponsiveMenuProps, ref: ForwardedRef<HTMLDivElement>) => {
    const { isResponsiveMenuDisplayed, setIsResponsiveMenuDisplayed } =
      useContext(ResponsiveMenuContext);

    const { userSession } = useGetSession();

    const { t } = useTranslation();

    const isUserAuthenTicated = status === "authenticated";

    const { isUserMenuDisplayed, setIsUserMenuDisplayed } = useContext(
      isUserMenuDisplayedContext
    );
    const { isTransparentDivDisplayed, setIsTransparentDivDisplayed } =
      useContext(isTransparentDisplayedContext);

    const handleDisplayUserMenu = () => {
      console.log("click");

      setIsTransparentDivDisplayed(true);
      setIsUserMenuDisplayed(!isUserMenuDisplayed);
    };

    return (
      <div ref={ref}>
        {isResponsiveMenuDisplayed && (
          <div className="absolute z-10 right-0 top-0 w-1/2 px-3 py-5 bg-white shadow-2xl">
            <div className={`${style.svgContainer}`}>
              <CloseMenu
                className={style.closeSvg}
                title="Fermer"
                onClick={() => setIsResponsiveMenuDisplayed(false)}
              />
            </div>

            <div className={style.menuLinkContainer}>
              {!isUserAuthenTicated && (
                <LinkMenu>
                  <div>
                    <Link href="/login" passHref>
                      <LoginIcon
                        className="svg"
                        title={t("navbar.button.login", "Login")}
                      />
                    </Link>
                  </div>
                </LinkMenu>
              )}
              {isUserAuthenTicated && (
                <div className={`clickable noselect relative`}>
                  <div className={`flex`} onClick={handleDisplayUserMenu}>
                    <p className="w-2/3">{userSession?.user?.firstName}</p>
                    <div className="w-1/3">
                      <OutlineIcon />
                    </div>
                  </div>
                  {isUserMenuDisplayed && (
                    <div className="absolute -left-10">
                      <UserMenu />
                    </div>
                  )}
                </div>
              )}
              <div onClick={() => setIsResponsiveMenuDisplayed(false)}>
                <Link href="/demo" passHref>
                  <p>
                    <FormattedMessage
                      id="navbar.button.demo"
                      defaultMessage="Demo"
                    />
                  </p>
                </Link>
              </div>
              {/* <div onClick={() => setIsResponsiveMenuDisplayed(false)}>
                <Link href={"/pricing"}>
                  <p>
                    <FormattedMessage
                      id="navbar.button.pricing"
                      defaultMessage="Pricing"
                    />
                  </p>
                </Link>
              </div> */}
              <div
                style={{ position: "relative", width: "100%", height: "20px" }}
              >
                <AppLangChoice />
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
);

export default ResponsiveMenu;
